import lazyWithRetry from "../utils/lazyWithRetry";
import { sortedReleases } from "../data/pressReleases";

// The homepage, where most visitors land, ships in the main bundle and its
// styles in the main stylesheet, which its prerendered page links: as a
// chunk of its own, the browser learned of its styles only once the main
// bundle had run, and showed the page unstyled until they came. It is still
// imported lazily, so nothing of it runs on the app's other pages.
// The version history (Pages/VersionHistory) is hidden for now: it has no
// route, and no page links to it.
const pages = [
  ["/", () => import(/* webpackMode: "eager" */ "../Pages/HomeEssenziale/HomeEssenziale")],
  ["/manifesto", () => import("../Pages/Manifesto/ManifestoPage")],
  ["/plans", () => import("../Pages/Plans/Plans")],
  ["/demo", () => import("../Pages/Demo/Demo")],
  ["/press", () => import("../Pages/Press/PressIndex")],
  ["/press/:slug", () => import("../Pages/Press/PressRelease")],
  ["/download", () => import("../Pages/Download/DownloadPage")],
  ["/terms", () => import("../Pages/Terms/Terms")],
  ["/referral-terms", () => import("../Pages/ReferralTerms/ReferralTerms")],
  ["/privacy", () => import("../Pages/Privacy/Privacy")],
  ["/cookie-policy", () => import("../Pages/Cookie/Cookie")],
];

const englishPath = (path) => path === "/" ? "/en" : `/en${path}`;

export const publicRoutes = pages.flatMap(([path, load]) => {
  const Component = lazyWithRetry(load);
  return [{ path, Component }, { path: englishPath(path), Component }];
});

export const publicPaths = pages.flatMap(([path]) => {
  const paths = path === "/press/:slug"
    ? sortedReleases().map(({ slug }) => `/press/${slug}`)
    : [path];
  return paths.flatMap((url) => [url, englishPath(url)]);
});

export function languageForLocation(pathname, search = "") {
  if (pathname === "/en" || pathname.startsWith("/en/")) return "en";
  if (publicPaths.includes(pathname)) return "it";
  return new URLSearchParams(search).get("lng") === "en" ? "en" : "it";
}
